// Copies of fe-nexus files; removed once they move to a GCP bucket (SO-33534).
// The only allow-list: the backend checks the name's shape, not membership.
export const ILLUSTRATION_URLS: Readonly<Record<string, string>> =
  Object.fromEntries(
    Object.entries(
      import.meta.glob<string>("@/assets/marketingBannerIllustrations/*.svg", {
        eager: true,
        query: "?url",
        import: "default",
      }),
    ).map(([path, url]) => [
      path.slice(path.lastIndexOf("/") + 1).replace(/\.svg$/, ""),
      url,
    ]),
  )

export const ILLUSTRATION_NAMES: readonly string[] =
  Object.keys(ILLUSTRATION_URLS)
